import { useEffect, useRef } from 'react';

import type { ParentElementName, ParentElementType } from './parent-element-view-context';
import { useTrackEvent } from './use-track-event';

type UseTrackElementViewProps = {
  elementName: ParentElementName;
  elementType: ParentElementType;
  isVisible: boolean;
};
/**
 * Track an event in MixPanel. Runs asynchronously and has a low chance of
 * failing without retries due to using raw `POST` under-the-hood. This is a
 * okay tradeoff for a method we'll be calling relatively frequently that does
 * not need to be 100% reliable
 *
import { useTrackEvent } from "./use-track-event";
 * @param event - The event to track
 * @param data - The payload associated with the event
 * @returns 
 */
export function useTrackElementView({
  elementName,
  elementType,
  isVisible = false,
}: UseTrackElementViewProps): () => void {
  const trackElementImpression = useTrackEvent('elementImpression');
  const trackElementViewDuration = useTrackEvent('elementViewDuration');
  const setVisibleTime = useRef<number | null>(null);

  useEffect(() => {
    if (isVisible) {
      setVisibleTime.current = Date.now();
      trackElementImpression({
        elementName,
        elementType,
      });
    }
  }, [isVisible]);

  return () => {
    if (setVisibleTime.current) {
      trackElementViewDuration({
        duration: Date.now() - setVisibleTime.current,
        elementName,
        elementType,
      });
    }
  };
}
